import React				from 'react';
import axios				from "axios";

import { useNavigate }		from "react-router";
import Box					from '@mui/system/Box';
import Stack				from '@mui/system/Stack';

import Input				from '@mui/joy/Input';
import {Typography}			from '@mui/joy';
import Button				from '@mui/joy/Button';
import Alert				from '@mui/joy/Alert';
import IconButton			from '@mui/joy/IconButton';


// Icons
import IcoGetCode 			from '@mui/icons-material/PhonelinkLockOutlined';
import IcoCloseRounded		from '@mui/icons-material/CloseRounded';
import IcoLogin			 	from '@mui/icons-material/LoginOutlined';

import {config} from "./config.js";


function Login() {
	const [showAlert, setshowAlert] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const [email, setEmail] = React.useState("");
	const [code, setCode] = React.useState("");
	const [codeSent, setCodeSent] = React.useState(false);
	const [errorMsg, setErrorMsg] = React.useState("");
	const navigate = useNavigate();
	
	function validEmail(m) {
		let regex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);
	
		return regex.test(m);	
	}
	
	function validFormat(c) {
		let regex = new RegExp(/^\d{4}$/);
		
		return regex.test(c);		
	}
	
	function getEmail(event) {
		setEmail(event.target.value);
		setshowAlert(false);
	}
	
	function getCode(event) {
		setCode(event.target.value);
		setshowAlert(false);				
	}
	
    function getValidationCode() {
	    
	    setLoading(true);
	    
		console.log("Get code", email);	    
	    	    
        var url = config.IP + "/get-code/" + email.trim();

		console.log("Calling", url);

		axios.get(url, {headers: {"content-type": "application/json"}})
			.then(response => {
				console.log("key:", response.data);
				setCodeSent(true);
				setLoading(false);
		})
		.catch(err => {
			var errCode = err.response.status;
			
			switch(errCode) {
				case 503: setErrorMsg("Unable to send SMS (503).");
					break;
					
				case 501: setErrorMsg("Duplicate email found (501).");
					break;

				case 404: setErrorMsg("No user with this email found (404).");
					break;

				default:
					setErrorMsg("Unexpected error: " + errCode);
			}
						
			console.log("get-code failed:", err.response.status);
			
			setshowAlert(true);
			setLoading(false);			
		});
    }

    function handleKeyPress(event) {
        if (event.key === "Enter") {
			getValidationCode();
        }
	}		

    function handleKeyPressCode(event) {
        if (event.key === "Enter")
	        validate(code);
	}		
	
	function validate(code) {
	    setLoading(true); 
	    	    
        var url = config.IP + "/valid-code/" + code.trim();
                
		axios.get(url, {headers: {"content-type": "application/json"}})
			.then(response => {
				console.log(response.data);
				localStorage.setItem("username", response.data);
				setLoading(false);
				navigate('/showstops');
		})
		.catch(err => {
			var errCode = err.response.status;
			
			switch(errCode) {
				case 501: setErrorMsg("Wrong code.");
					break;
					
				case 509: setErrorMsg("Code has expired.");
					break;

				case 503: setErrorMsg("Server responded with error. Try again.");
					break;

				default:
					setErrorMsg("Unexpected error: " + errCode);
			}
			
			setshowAlert(true);
			setLoading(false);
		});

	}

	return (
		<React.Fragment>

			<Stack direction="column" sx={{mt: 3}} justifyContent="center" alignItems="center" spacing={0.7}>
				<IconButton color="success"><IcoLogin style={{ fontSize: 60 }}/></IconButton>
			 	<Typography sx={{mt:1}} align="center" level="h3">Login</Typography>
			 	<Typography align="center" level="body-lg" style={{ lineHeight: "20px" }}>Enter email and click button to get a <Typography display="block"/>code sent to your mobile (or email account).</Typography>				

			 	<Stack spacing={1} sx={{ width: 450 }}>
					<Input autoFocus size="lg" placeholder="Email" type="email" onChange={getEmail} onKeyPress={handleKeyPress} 
						endDecorator={
							<Button sx={{ width: 148 }} size="lg" disabled={!validEmail(email)} onClick={getValidationCode} loading={loading} startDecorator={<IcoGetCode />}>
								Get code
							</Button>
						}
					/>
	
					<Input disabled={!codeSent} size="lg" placeholder="Enter 4-digit code" type="number" onChange={getCode}  onKeyPress={handleKeyPressCode} 
						endDecorator={
						 	<Button sx={{ width: 148 }} size="lg" disabled={!(codeSent && validFormat(code))} variant="soft" color="success" startDecorator={<IcoLogin />} onClick={() => {validate(code)}}>
						 		Login
							</Button>
						}				
					/>
				</Stack>

			</Stack>
						
			<Box sx={{	flexGrow: 1,
		  				display: 'flex',
		  				m: 2,
		  				alignItems: 'center',
		  				justifyContent: 'center'
		  		}}
		  	>
				{showAlert && 
					<Alert
						variant="soft"
						color="danger">
						{errorMsg}
						<IconButton variant="soft" size="lg" color="danger" onClick={() => {setshowAlert(false)}}>
						  <IcoCloseRounded />
						</IconButton>
					</Alert>
				}			
			</Box>
		
		</React.Fragment>
	)
}

export default Login;